import React from "react";
import "./blogs.css";
import { Container } from "react-bootstrap";

const BlogPage = () => {
  return (
    <Container>
        <div className="blog-container">
        <h1 className="blog-title">Top Reasons to Buy a Plot in Kanchipuram</h1>
        <p className="blog-intro">
            Are you planning to invest in land? Then Kanchipuram is one of the best
            places you should consider. Known as the "City of Temples", Kanchipuram
            is not just a religious and cultural hotspot, but also a growing real
            estate destination. Whether you're looking to build your dream home or
            want to make a smart investment, buying a plot in Kanchipuram can be a
            great decision.
        </p>

        <h2 className="blog-heading">1. Affordable Land Prices</h2>
        <p>
            Compared to Chennai and nearby metro cities, the cost of land in
            Kanchipuram is still affordable. You can get spacious plots at a much
            lower price, making it ideal for middle-class families and first-time
            investors.
        </p>

        <h2 className="blog-heading">2. Good Connectivity</h2>
        <p>
            Kanchipuram is well-connected by road and rail. The Chennai-Bangalore
            Highway (NH 48) passes through the area, and regular buses and trains
            make travel easy. You can reach Chennai in just 1.5 to 2 hours, making
            it a perfect weekend getaway or a peaceful place to settle.
        </p>

        <h2 className="blog-heading">3. Rapid Development</h2>
        <p>
            The city is growing fast. With new schools, colleges, hospitals, and
            shops opening up, the overall infrastructure is improving. This means
            the value of your plot will likely increase in the future.
        </p>

        <h2 className="blog-heading">4. Peaceful Environment</h2>
        <p>
            Unlike the busy and noisy life of big cities, Kanchipuram offers a calm
            and peaceful atmosphere. If you’re planning to build a house, this is a
            great place to live with your family in a stress-free environment.
        </p>

        <h2 className="blog-heading">5. Great for Investment</h2>
        <p>
            Land is always a good long-term investment. With the growing popularity
            of Kanchipuram, the demand for plots is increasing. If you buy now, you
            may get a good return in the coming years.
        </p>

        <h2 className="blog-heading">6. Rich Cultural Heritage</h2>
        <p>
            Kanchipuram is famous for its temples, silk sarees, and rich history.
            Living in such a culturally rich town adds a unique charm to your
            lifestyle. Many people prefer to retire here for a peaceful and
            meaningful life.
        </p>

        <div className="blog-conclusion">
            <p>
            Buying a plot in Kanchipuram is not just a smart investment, it’s also
            a step toward a better and more peaceful lifestyle. Whether you plan
            to build a home now or in the future, Kanchipuram has everything you
            need — affordability, connectivity, safety, and growth potential.
            </p>
            <p>
            <strong>So why wait?</strong> Start your journey towards land
            ownership today and watch your investment grow in this beautiful and
            historic town!
            </p>
        </div>
        </div>
    </Container>
  );
};

export default BlogPage;
